import axios from '@/utils/request';

export async function fetchUserInfo() {
    return axios.get('user/current');
}
